export default "__VITE_PUBLIC_ASSET__2b00f6c5__"